import React from 'react';
import TwoFactor from 'components/Login/TwoFactor';

export default (props) => <TwoFactor {...props} />;
